import { Request } from './base/Request';
import { Method } from 'axios';
import { ConfiguratorData } from '@/types/Configurator/ConfiguratorData';
import { FilterData } from '@/types/Filters/FilterData';
import { ExtraOptionsData } from '@/types/ExtraOptions/ExtraOptionsData';
import { SizeData } from '@/types/Configurator/SizeData';
import { MediaclipData } from '@/types/Mediaclip/MediaclipData';

type RequestData = {
  configurator: ConfiguratorData;
  filter: FilterData;
  size: SizeData;
  extra_options: ExtraOptionsData;
  mediaclip: MediaclipData;
};

export default class StateUpdateRequest extends Request<unknown, RequestData> {
  private identifier: string = '';

  protected getEndPoint(): string {
    return `${window.base_url}rest/V1/canvascompany/product-configurator/save-state/${this.identifier}`;
  }

  protected getMethod(): Method {
    return 'POST';
  }

  setIdentifier(value: string): this {
    this.identifier = value;
    return this;
  }

  setData(data: RequestData): this {
    this.data = data;
    return this;
  }
}
